import { CustomError } from './customError';

/**
 * Apiで権限エラーの場合
 */
export class Api403ForbiddenError extends CustomError { }
